/**
 * @packageDocumentation
 * @module api.functional.event_logs
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CompanyScopeQuery } from "../../structures/CompanyScopeQuery";
import type { EventLogActor } from "../../structures/EventLogActor";
import type { EventLogQuery } from "../../structures/EventLogQuery";
import type { PageOfEventLogView } from "../../structures/PageOfEventLogView";

export * as event_types from "./event_types/index";

/**
 * @controller EventLogController.list
 * @path GET /event-logs
 * @accessor api.functional.event_logs.list
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function list(
  connection: IConnection,
  query: list.Query,
): Promise<list.Output> {
  return PlainFetcher.fetch(connection, {
    ...list.METADATA,
    template: list.METADATA.path,
    path: list.path(query),
  });
}
export namespace list {
  export type Query = EventLogQuery;
  export type Output = PageOfEventLogView;

  export const METADATA = {
    method: "GET",
    path: "/event-logs",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/event-logs";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller EventLogController.actors
 * @path GET /event-logs/actors
 * @accessor api.functional.event_logs.actors
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function actors(
  connection: IConnection,
  query: actors.Query,
): Promise<actors.Output> {
  return PlainFetcher.fetch(connection, {
    ...actors.METADATA,
    template: actors.METADATA.path,
    path: actors.path(query),
  });
}
export namespace actors {
  export type Query = CompanyScopeQuery;
  export type Output = EventLogActor[];

  export const METADATA = {
    method: "GET",
    path: "/event-logs/actors",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/event-logs/actors";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
